import { FullWidthImage } from './FullWidthImage'
import { ImageGallery } from './ImageGallery'
import { ImageHighlight } from './ImageHighlight'
import { Quote } from './Quote'
import { Text } from './Text'

export const components = {
  full_width_image: FullWidthImage,
  image_gallery: ImageGallery,
  image_highlight: ImageHighlight,
  quote: Quote,
  text: Text,
}